<template>
  <div>
    <div class="home--banner">
      <div class="home--banner__solgan mB24">
        <div class="ly--content--container">
          <div class="row mb24">
            <div class="col col-lg-auto txt-upper home--banner__title">
              <!-- <div class="home--banner__title txt-upper"> -->
              <h2 class="fw-bold" v-html="$t('banner.top1')"></h2>
              <h3 v-html="$t('banner.top2')"></h3>
              <!-- </div> -->

              <div
                class="text-center d-block d-md-none mT16 home--banner__solgan--bold"
              >
                <div
                  :style="{ backgroundColor: selectedColor }"
                  class="home--banner__only"
                  v-html="$t('banner.only')"
                ></div>
              </div>
            </div>
            <div class="col-auto col-lg-auto">
              <a href="#special" class="button primary">
                {{ $t("common.offer") }}
              </a>
            </div>
          </div>
          <div class="text-center d-none d-md-block mT16">
            <div
              :style="{ backgroundColor: selectedColor }"
              class="home--banner__only"
              v-html="$t('banner.only')"
            ></div>
          </div>
        </div>
      </div>

      <div class="home--banner__mobile--container">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="home--banner__machine--outer">
              <div
                :key="index"
                v-for="(item, index) in productInfo"
                v-show="item.colorValue === selected.colorValue"
                class="home--banner__machine--wrapper"
              >
                <div
                  class="home--banner__machine--bg"
                  :style="{ backgroundColor: selectedColor }"
                ></div>
                <ImageWrapper
                  class="home--banner__machine--main--bg"
                  alt=""
                  src="https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/machine_bg.png"
                />

                <div class="home--video__img">
                  <ImageWrapper
                    class="home--video__machine"
                    :src="`https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/vertuo-${item.colorValue}.png`"
                    alt=""
                  />
                  <ImageWrapper
                    :src="`https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/banner_discount_${
                      $i18n.locale === 'en' ? 'en' : 'tc'
                    }.png`"
                    alt=""
                    class="home--video__discount"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="home--banner__right">
              <div
                class="h1 txt-upper home--banner__sub mB8"
                v-html="$t('banner.title')"
              ></div>
              <p
                class="body-small home--banner__desc mB8"
                v-html="$t('banner.desc')"
              ></p>

              <div
                class="h2 col__green fw-bold mB8"
                v-html="$t('banner.price')"
              ></div>

              <p class="body-small mB14">
                <span v-html="$t('banner.colorSelected')"></span>
                <span :style="{ color: selected.color }">{{
                  $i18n.locale == "en"
                    ? selected.color_name_en
                    : selected.color_name_tc
                }}</span>
              </p>

              <div class="home--banner__colors mB24">
                <div class="row">
                  <div
                    class="col-auto"
                    v-for="(item, index) in productInfo"
                    :key="index"
                  >
                    <a
                      @click="selected = item"
                      class="home--banner__color--item"
                      :class="{
                        selected: item.colorValue === selected.colorValue,
                      }"
                      :style="{ backgroundColor: item.color }"
                    ></a>
                  </div>
                </div>
              </div>

              <div class="mB24">
                <AddToCart
                  v-show="item.colorValue === selected.colorValue"
                  :id="item.sku"
                  v-for="(item, index) in productInfo"
                  :key="index"
                />
              </div>
            </div>
            <div class="mB24">
              <h3
                class="fw-bold home--banner__addOn"
                v-html="$t('banner.addOn')"
              ></h3>
            </div>
          </div>
        </div>
      </div>

      <div class="home--banner__scroll--wrapper">
        <div class="home--banner__scroll">
          <Icons name="downl" />
          <p v-html="$t('banner.scrollToSee')"></p>
        </div>
      </div>
    </div>

    <div class="special__wrapper" :style="{ backgroundColor: selectedColor }">
      <div class="special__content">
        <ImageWrapper
          src="https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/special-mug.png"
          class="special__mug"
          alt=""
          v-parallax.centerX="0.04"
        />

        <div v-parallax.absY="0.05">
          <ImageWrapper
            src="https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/special-capAltissio.png"
            class="special__cap special__capAlt"
            alt=""
          />
        </div>
        <div v-parallax.absY="0.12">
          <ImageWrapper
            src="https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/special-capRoasted.png"
            class="special__cap special__capRoast"
            alt=""
          />
        </div>

        <ImageWrapper
          src="https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/special-capOdacio.png"
          class="special__cap special__capOdacio"
          alt=""
          v-parallax.absY="0.055"
        />

        <ImageWrapper
          :src="`https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/special-${selected.colorValue}.png`"
          class="special__machine"
          id="special"
          :alt="selected.color_name_en"
        />

        <div class="special__txt text-center">
          <div
            class="special__title txt-upper h1 fw-bold"
            :style="{ color: selectedColor }"
            v-html="$t('special.title')"
          ></div>
          <div class="special__desc h1 mB16" v-html="$t('special.desc')"></div>
          <p
            class="body-small fw-bold text-center mB16 special__detail"
            v-html="$t('special.detail')"
          ></p>

          <div class="mB16">
            <a @click="$emit('showTnc')" class="link">{{
              $t("common.learnMore")
            }}</a>
          </div>

          <div class="mB20">
            <div>
              <span class="h3 fw-bold col__green">{{
                $t("special.price")
              }}</span>
              <span class="body-small col__grey mL14 txt-delete">{{
                $t("special.priceTotal")
              }}</span>
            </div>
          </div>

          <div>
            <AddToCart id="142997" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import data from "~/data/machine.js";
import { AddToCart, Icons } from "../index.js";

import ImageWrapper from "../atoms/ImageWrapper.vue";

export default {
  name: "homeBanner",
  components: { AddToCart, Icons, ImageWrapper },
  computed: {
    productInfo() {
      return data.machine;
    },
    selectedColor() {
      return this.selected.color;
    },
  },
  setup() {
    return { initData: data.machine[0] };
  },

  data() {
    return {
      selected: this.initData,
    };
  },
};
</script>

<style lang="scss">
@import "~/scss/include/_commonInclude.scss";
.content .app {
  .home--banner {
    background: color(whiteAbs);
    color: color(black);
    padding-top: rem(24);
    padding-bottom: rem(52);
    overflow: hidden;

    &__mobile--container {
      @include media-breakpoint-down(md) {
        padding: 0 rem(20);
        text-align: center;
      }
    }

    &__addOn {
      font-size: rem(20) !important;

      @include media-breakpoint-down(md) {
        font-size: rem(16) !important;
      }
    }

    &__solgan {
      padding-bottom: rem(16);
      position: relative;

      &:after {
        content: "";
        width: rem(40);
        height: rem(6);
        border-radius: 1000px;
        background-color: color(gold);
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }

      @include media-breakpoint-down(md) {
        .row {
          --bs-gutter-x: #{rem(12)};
        }
        .button {
          font-size: rem(14);
          padding: 8px 12px;
        }
      }
    }

    &__only {
      display: inline-block;
      font-size: rem(24);
      text-transform: uppercase;
      letter-spacing: 0.1em;
      line-height: 1.1em;
      padding: rem(8) rem(20);
      color: color(whiteAbs);
      font-weight: 700;
      position: relative;

      @include media-breakpoint-down(md) {
        font-size: rem(14);
        padding: rem(8);
      }

      &:after {
        content: "";
        position: absolute;
        top: 3px;
        left: 3px;
        right: 3px;
        bottom: 3px;
        border: 1px solid color(whiteAbs);

        @include media-breakpoint-down(md) {
          top: 2px;
          left: 2px;
          right: 2px;
          bottom: 2px;
        }
      }
    }

    &__scroll {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: auto;
      margin-right: auto;
      text-align: center;

      img {
        width: rem(24);
        height: rem(24);
        margin-bottom: rem(8);
      }

      font-size: rem(12);
      line-height: em(14.4, 12);
    }

    &__video {
      width: 100%;
      aspect-ratio: 1845 /1080 * 1;
      position: absolute;
      margin: auto;
      z-index: 100;
      top: 0;
      left: 0;

      video {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
    }

    &__discount {
      position: absolute;
      z-index: 1;
      width: 35%;
      top: 4%;
      left: 0;
    }

    &__solgan {
      @include media-breakpoint-down(md) {
        max-width: 445px;
        margin-left: auto;
        margin-right: auto;

        &--bold {
          margin-top: rem(8) !important;
        }
      }

      .row {
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
      }
    }

    &__colors {
      @include media-breakpoint-down(md) {
        display: flex;
        justify-content: center;
      }
    }

    &__machine {
      &--outer {
        max-width: rem(458);
        margin-left: auto;
        @include media-breakpoint-down(md) {
          margin-right: auto;
        }
      }

      &--wrapper {
        position: relative;
        max-width: rem(354);
        width: 100%;

        .home--video__img {
          position: relative;
          top: inherit;
          left: inherit;
          width: 90%;
          display: block;

          @include media-breakpoint-down(md) {
            transform: translateX(-6.5%);
          }
        }

        @include media-breakpoint-down(md) {
          margin-left: auto;
          margin-right: auto;
          width: 80%;
        }
      }

      &--img {
        width: 211/380 * 100%;
        display: block;
        position: relative;
        margin-left: auto;
        margin-right: auto;
      }

      &--bg {
        display: block;
        width: 122/380 * 100%;
        aspect-ratio: 1;
        position: absolute;
        bottom: 0;
        right: 0;

        @include media-breakpoint-down(md) {
          right: 5%;
        }
      }

      &--main--bg {
        display: block;
        width: 122/380 * 100%;
        aspect-ratio: 1;
        position: absolute;
        bottom: 50%;
        transform: translateY(50%);
        left: 5%;
      }
    }

    &__right {
      padding-top: rem(45);
      max-width: rem(370);

      @include media-breakpoint-down(md) {
        text-align: center;
        max-width: inherit;
      }
    }

    &__left {
      max-width: rem(350);
    }

    &__solgan {
      > .row {
        justify-content: center;
      }
    }

    &__title {
      letter-spacing: 0.1em;
      line-height: 1.2em;

      // h1 {
      //   display: inline;
      // }
      // @include media-breakpoint-down(md) {
      //   text-align: right;
      // }
      text-align: right;
      > * {
        display: inline-block;
      }

      @include media-breakpoint-down(md) {
        text-align: center;

        h2,
        h3 {
          font-size: rem(16);
          line-height: 1.2em;
          display: inline;
        }
      }
    }

    &__sub {
      letter-spacing: 0.1em;
      line-height: 1.2em;

      @include media-breakpoint-down(md) {
        font-size: rem(24);
      }
    }

    &__desc {
    }

    &__color {
      &--item {
        width: rem(28);
        aspect-ratio: 1;
        display: inline-block;
        position: relative;
        cursor: pointer;
        border-radius: 100%;

        &.selected {
          &:before {
            content: "";
            position: absolute;
            width: calc(100% - 2px);
            top: 0;
            left: 0;
            border-radius: 100%;
            aspect-ratio: 1;
            border: 1px solid color(grey);
            display: block;
            background: transparent;
          }

          &:after {
            content: "";
            position: absolute;
            width: calc(100% - 4px);
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border-radius: 100%;
            aspect-ratio: 1;
            border: 1px solid color(whiteAbs);
            display: block;
            background: transparent;
          }
        }
      }
    }
  }
  .special {
    &__machine {
      // width: rem(218);
      width: 218/980 * 100%;
      min-width: rem(203);
      top: 0;
      right: 5%;
      position: absolute;
      transform: translate(0, -85%);

      @include media-breakpoint-down(md) {
        width: 32.244898%;
        min-width: inherit;
      }
    }
    &__cap {
      position: absolute;
    }

    &__capAlt {
      top: 0;
      width: 139/980 * 100%;
      min-width: rem(120);
      left: 10%;
      transform: translate(0, -54%);

      @include media-breakpoint-down(md) {
        top: -11px;
        width: 23.183673%;
        min-width: inherit;
        // left: 2%;
        left: -6%;
      }
    }

    &__capRoast {
      width: 131/980 * 100%;
      min-width: rem(120);
      top: 40%;
      right: 0;
      transform: translate(50%, -50%);

      @include media-breakpoint-down(md) {
        width: 23.367347%;
        // min-width: inherit;
        // right: 25px;
        // width: 16.367347%;
        min-width: inherit;
        right: 17px;
      }
    }

    &__capOdacio {
      width: 130/980 * 100%;
      min-width: rem(120);
      bottom: 0;
      right: 12%;
      transform: translate(0%, 50%);

      @include media-breakpoint-down(md) {
        width: 25%;
        min-width: inherit;
        bottom: 10px;
        right: 5%;
      }
    }

    &__mug {
      // width: rem(171);
      width: 171/980 * 100%;
      min-width: rem(150);
      position: absolute;
      bottom: rem(6);
      left: 0;
      transform: translate(-50%, 5%);

      @include media-breakpoint-down(md) {
        bottom: rem(32);
        // left: -23px;
        left: 7%;
        transform: inherit;
        width: 28%;
        min-width: inherit;
      }
    }

    &__title {
      letter-spacing: 0.2em;
      text-align: center;
      margin-bottom: rem(16);
      line-height: 1.2em;

      @include media-breakpoint-down(md) {
        font-size: 24px;
        letter-spacing: 0.1em !important;
      }
    }

    &__desc {
      text-align: center;
      line-height: 1.2em;

      @include media-breakpoint-down(md) {
        font-size: rem(18);
      }
    }

    &__detail {
      color: color(grey);
      b {
        color: color(black);
        font-weight: 700;
      }
    }

    &__wrapper {
      padding: rem(24) rem(85);
      z-index: 10;
      position: relative;

      @include media-breakpoint-down(lg) {
        padding: rem(24) 10%;
      }

      @include media-breakpoint-down(md) {
        padding: rem(24) rem(16);
      }
    }
    &__txt {
      padding: rem(24) rem(85);

      @include media-breakpoint-down(md) {
        padding: 1.5rem rem(20);
      }
    }
    &__content {
      position: relative;
      color: color(black);
      background-color: color(whiteAbs);
      border-radius: rem(16);

      max-width: rem(989);
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      min-height: rem(413);

      @include media-breakpoint-down(md) {
        max-width: 440px;
        min-height: inherit;
      }
    }
  }
}
</style>
